import React from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { useSelector } from "react-redux";
import RTL from "./layouts/full-layout/customizer/RTL";
import ThemeSettings from "./layouts/full-layout/customizer/ThemeSettings";
import "react-perfect-scrollbar/dist/css/styles.css";
import { AuthProvider } from "./authentication/AuthProvider";
import AppWrapper from "./app-wrapper";
import "./css/loader.css";
import "react-datepicker/dist/react-datepicker.css";

const App = () => {
  const theme = ThemeSettings();
  const customizer = useSelector((state) => state.CustomizerReducer);
  
// useEffect(() => {
//   createChat({
//     webhookUrl: "http://54.160.189.87:5678/webhook/81984259-0ebd-48ca-b88a-f4583fdfbd67/chat",
//     title: "SSW AI Bot",
//     subtitle: "We're here to help you",
//     showLauncher: false,

//     initialMessages: [
//       "Hello! 👋",
//       "Welcome to SSW AI. How can I help you?"
//     ],

//     theme: {
//       primaryColor: "#FB9678",
//       textColor: "#ffffff",
//       backgroundColor: "#ffffff",
//     }
//   });
// });
  return (
    <ThemeProvider theme={theme}>
      <RTL direction={customizer.activeDir}>
        <CssBaseline />
        <AuthProvider>
          <AppWrapper />
          {/* <button
 onClick={() => {
    debugger; // 👈 pause here in DevTools
    console.log("Button clicked");
    console.log("n8nChat object:", window.n8nChat);

    window.n8nChat?.toggle();
  }}
  style={{
    position: "fixed",
    bottom: "60px",
    right: "20px",
    background: "linear-gradient(135deg, #FB9678, #f36539)",
    color: "#fff",
    borderRadius: "30px",
    padding: "12px 18px",
    border: "none",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
    zIndex: 9999
  }}
>
  💬 Ask SSW AI
</button>
<div style={{
  position: "fixed",
  bottom: "110px",
  right: "20px",
  background: "#fff9f6",
  padding: "8px 12px",
  borderRadius: "10px",
  fontSize: "13px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
}}>
  Hello 👋 SSW AI
</div> */}
        </AuthProvider>
      </RTL>
    </ThemeProvider>
  );
};

export default App;
